export default __webpack_public_path__ + "static/og-image-3b76dd3749fe3c509a60fc1694d9dc29.png";